import * as core from '../../../../../../../core'

export const RESOURCE = {
  payload: {
    alias: 'proposal.details',
    name: 'Proposal Details',
    description: 'Proposal details page',
    variables: [],
    content: {
      root: {
        elements: [
          {
            height: 260,
            content: {
              widget: {
                widget: {
                  alias: 'proposal.attributes',
                },
              },
            },
          },
          {
            height: 320,
            content: {
              widget: {
                widget: {
                  alias: 'proposal.personnel.table',
                },
              },
            },
          },
          {
            height: 320,
            content: {
              widget: {
                widget: {
                  alias: 'proposal.domain.table',
                },
              },
            },
          },
        ],
      },
    },
  },
  type: core.quiver.Resource.Type.MosaicPage,
} as const satisfies core.quiver.Resource<core.quiver.Resource.Type.MosaicPage>
